import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { ref } from 'vue';
import { useForm } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  setup(__props) {

const { i18n } = useContext();
const { formSuccess, formPending, submit } = useForm();

const form = ref({
  type: 'canyon_contact',
  name: '',
  email: '',
  country: '',
  message_subject: null,
  comment: '',
});
const submitForm = () => {
  submit(form.value);
};

const messageSubjects = [
  {
    id: 1,
    name: i18n.t('website_content'),
  },
  {
    id: 2,
    name: i18n.t('sales_inquily'),
  },
  {
    id: 3,
    name: i18n.t('press_relation'),
  },
  {
    id: 4,
    name: i18n.t('other'),
  },
];

return { __sfc: true,i18n, formSuccess, formPending, submit, form, submitForm, messageSubjects }
}

})